import qureyString from "query-string";
import { getLogger } from "@cld/upload-widget";
import { api } from "services";
import { localStorage } from "utils/domUtils";
import appConfig from "appConfig";
import { COLOR_TYPE_BLACK_AND_WHITE, DEFAULT_PAGE_SIZE, LICENSE_URL } from "../data/consts";

const logger = getLogger();

const serverBase = appConfig.unsplash.baseUrl;
const { apiSubDomain } = appConfig.unsplash;
const { apiKey } = appConfig.unsplash;
const { appName } = appConfig.unsplash;

const LS_API_DOMAIN_KEY = "UW_unsplash_Api";

const getBaseUrl = () => {
	const subDomainOverride = localStorage.getItem(LS_API_DOMAIN_KEY);
	const subDomain = subDomainOverride || apiSubDomain;

	return `https://${subDomain}${serverBase}`;
};

const getRequestHeaders = () => {

	return {
		"authorization": `Client-ID ${apiKey}`,
		"Content-Type": "application/json",
		"Accept-Version": "v1"
	};
};

export const addTrackingParams = (url: string, appName: string) => {
	const parsedUrl = qureyString.parseUrl(url);
	parsedUrl.query["utm_source"] = appName;
	parsedUrl.query["utm_medium"] = "referral";

	const params = qureyString.stringify(parsedUrl.query, { encode: false });
	return `${parsedUrl.url}?${params}`;
};

const processResults = (items) => items.map((item) => {
	const result = {
		...item,
		allowSelect: true,
		title: item.description || item.alt_description,
		link: addTrackingParams(item.links.html, appName),
		preview_link: addTrackingParams(item.links.html, appName),
		regular_image: item.urls.regular,
		download_location: item.links.download_location,
		thumbnail: item.urls.thumb,
	};
	result.user.links.html = addTrackingParams(result.user.links.html, appName);
	return result;
});

export default () => {
	const baseUrl = getBaseUrl();

	const getHomeAssets = async ({ page, perPage, orderBy }) => {
		const apiURL = `${baseUrl}photos`;
		let response;
		try {
			response = await api.get(apiURL, { page, per_page: perPage, order_by: orderBy }, { headers: getRequestHeaders() });
		}
		catch (e) {
			logger.log(`[unsplash]: failed to retrieve assets from ${apiURL}`);
		}

		if (response) {
			return { items: processResults(response), hasMoreAssets: Boolean(response.length), page };
		}
		else {
			return {
				error: true
			};
		}
	};

	const getSearchResults = async (searchParams) => {
		const { searchPhrase: query, page = 1, orderBy, filters } = searchParams;
		let apiURL = `${baseUrl}search/photos`;

		if (!query) {
			return getHomeAssets({ page, perPage: DEFAULT_PAGE_SIZE, orderBy });
		}
		const requestParams = { page, per_page: DEFAULT_PAGE_SIZE, order_by: orderBy, query};
		if (filters?.orientation) {
			requestParams.orientation = filters.orientation;
		}
		if (filters?.color) {
			requestParams.color = filters.color;
		}
		if (filters?.colorType === COLOR_TYPE_BLACK_AND_WHITE ) {
			requestParams.color = COLOR_TYPE_BLACK_AND_WHITE;
		}


		let response;
		try {
			response = await api.get(apiURL, requestParams, { headers: getRequestHeaders() });
		}
		catch (e) {
			logger.log(`[unsplash]: failed to retrieve assets from ${apiURL}`);
		}

		if (response) {
			return { items: processResults(response.results), hasMoreAssets: response.total_pages > page, page};
		}
		else {
			return {
				error: true
			};
		}
	};
	const getTopics = async (searchParams) => {
		const { slug, page, orderBy, filters } = searchParams;
		const apiURL = `${baseUrl}topics/${slug}/photos`;

		const requestParams = { page, per_page: 30, order_by: orderBy };
		if (filters?.orientation) {
			requestParams.orientation = filters.orientation;
		}
		let response;
		try {
			response = await api.get(apiURL, requestParams, { headers: getRequestHeaders() });
		}
		catch (e) {
			logger.log(`[unsplash]: failed to retrieve assets from ${apiURL}`);
		}

		if (response) {
			return { items: processResults(response), hasMoreAssets: Boolean(response.length), page };
		}
		else {
			return {
				error: true
			};
		}
	};
	const download = async (url, height) => {

		let response;
		try {
			response = await api.get(url, null, { headers: getRequestHeaders() });
		}
		catch (e) {
			logger.log(`[unsplash]: failed to download assets from ${url}`);
		}

		if (response?.url) {
			const imageURL = `${response.url}&h=${height}`;
			await api.preloadImage(imageURL);
			return imageURL;
		}
		else {
			return {
				error: true
			};
		}
	};

	const retrieveAssetDetails = async (id) => {

		let response;
		const apiURL = `${baseUrl}photos/${id}`;
		try {
			response = await api.get(apiURL, null, { headers: getRequestHeaders() });
		}
		catch (e) {
			logger.log(`[unsplash]: failed to retrieveAssetDetails assets for id ${id}`);
		}

		if (response) {
			if (response?.user) {
				response.user.links.html = addTrackingParams(response.user.links.html, appName);
			}
			return response;
		}
		else {
			return {
				error: true
			};
		}
	};

	const getLicenseUrl = () => addTrackingParams(LICENSE_URL, appName);

	return {
		getHomeAssets,
		getSearchResults,
		getTopics,
		download,
		retrieveAssetDetails,
		getLicenseUrl,
	};
};
